<template>
	<header class="header">
        <span v-if="isDesktop" class="header__button_show_menu" @click="toggleSidebar()">
            <i class="fas fa-bars header__menu"></i>
        </span>
		<div class="header__sync">
			<button v-if="$route.path.trim() == '/'" type="button" class="sync" @click="syncronize()">
                <span class="sync__label">
                    Aggiorna
                </span>
				<span class="sync__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 85"><path
							d="M66.958 47.703c-1.39 8.855-6.136 16.638-13.365 21.913-6.222 4.542-13.64 6.75-21.222 6.391l5.54 5.292-3.52 3.703-8.556-8.173-.002.001-3.794-3.629 3.518-3.703.002.003 8.152-8.58 3.796 3.632-4.111 4.324c.021.001.044-.002.065-.001l-1.085 1.142c6.319.362 12.516-1.458 17.699-5.242 5.938-4.335 9.838-10.728 10.979-18.002 1.731-11.036-3.363-21.595-12.131-27.358l4.108-4.448c10.156 7.127 15.975 19.657 13.927 32.735zM42.447 15.499l-8.152 8.579-3.796-3.632 4.111-4.323c-.021-.001-.044.002-.065.001l1.085-1.142c-6.319-.362-12.516 1.458-17.699 5.242-5.938 4.334-9.838 10.728-10.979 18.002-1.731 11.036 3.363 21.593 12.128 27.358l-4.108 4.449C4.817 62.905-1.003 50.376 1.048 37.297c1.39-8.855 6.136-16.638 13.366-21.914 6.221-4.541 13.639-6.75 21.221-6.39l-5.54-5.292 3.52-3.703 8.556 8.173.002-.001 3.794 3.629-3.518 3.703-.002-.003z"/></svg>
                </span>
			</button>
			<router-link v-if="$route.path.trim() != '/'" class="inverse" :to="{ name: 'dashboard'}">
                <span class="inverse__icon">
                    <span class="bar"></span>
                    <span class="bar"></span>
                </span>
				<span class="inverse__label">
                    {{ $t('common.back') }}
                </span>
			</router-link>
		</div>
		<div class="header__avatar">
			<span class="text-light">{{ profile.name }}</span>
			<span class="logout" @click="logout()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 37"><path
						d="M49.988 18.726a1.735 1.735 0 01-.024.161c-.003.019-.005.039-.009.058a1.703 1.703 0 01-.048.19l-.006.024a1.957 1.957 0 01-.067.186l-.008.022a2.19 2.19 0 01-.08.17l-.015.03a2.17 2.17 0 01-.089.149l-.026.042c-.031.046-.065.09-.1.134-.011.014-.021.03-.033.044a2.099 2.099 0 01-.149.164l-6.818 6.784a2.28 2.28 0 01-3.214 0 2.253 2.253 0 010-3.198l2.938-2.924H15.909a2.267 2.267 0 01-2.272-2.262 2.266 2.266 0 012.272-2.261H42.24l-2.938-2.924a2.256 2.256 0 010-3.199 2.273 2.273 0 011.607-.662c.582 0 1.163.221 1.607.662l6.818 6.785c.053.052.102.107.15.164l.032.043c.034.044.069.088.1.135l.025.04c.031.049.062.099.09.15l.014.03a2.2 2.2 0 01.081.17l.008.021c.025.061.048.124.067.187l.006.023c.019.063.035.126.048.191l.009.057c.009.053.019.107.024.162a2.139 2.139 0 010 .452zm-19.749-8.039a14.061 14.061 0 00-11.648-6.163c-7.745 0-14.046 6.269-14.046 13.976 0 7.707 6.301 13.977 14.046 13.977 4.687 0 9.049-2.314 11.667-6.192a2.28 2.28 0 013.154-.615 2.254 2.254 0 01.619 3.138A18.6 18.6 0 0118.591 37C8.34 37 0 28.701 0 18.5S8.34 0 18.591 0a18.61 18.61 0 0115.415 8.155 2.255 2.255 0 01-.611 3.14 2.28 2.28 0 01-3.156-.608z"/></svg>
            </span>
			<div class="dropdown" v-bind:class="{'dropdown--active': profileOpen}">
				<ul class="dropdown__list">
					<!--<li class="dropdown__list-item" @click="goProfile()">
						<span class="dropdown__icon"><i class="far fa-user"></i></span>
						<span class="dropdown__title text-light">{{ $t('layout.header.profile')}}</span>
					</li>-->
					<li class="dropdown__list-item">
						<span class="dropdown__icon"><i class="fas fa-sign-out-alt"></i></span>
						<span class="dropdown__title text-light">{{ $t('layout.header.logout')}}</span>
					</li>
				</ul>
			</div>
		</div>
		<confirm-modal v-model="modalLogoutOpen" v-bind:title="$t('layout.header.logout')"
					   v-bind:text="$t('layout.header.logout_message')"
					   @result="closeLogoutModal($event)"></confirm-modal>
		<span class="syncstatus" v-bind:class="{'active': messageSync != 'end'}" v-if="messageSync">
            <span>{{ $t(`common.sync.${messageSync}`, { data: messageSyncParams }) }}...</span>
        </span>
	</header>

</template>
<script>
    import ConfirmModal from "../ConfirmModal";

    export default {
        name: 'header-component',
        components: {
            ConfirmModal
        },
        props: {
            value: {
                required: true
            }
        },
        data() {
            this.getProfile();
            return {
                loadingProfile: false,
                profile: {},
                profileOpen: false,
                sidebarOpen: true,
                modalLogoutOpen: false,
                sync: this.sync,
                messageSync: '',
                messageSyncParams: ''
            };
        },
        methods: {
            syncronize() {
                if (navigator.onLine) {
                    this.sync.syncronizeTable('customers', (updated, params) => {
                        this.messageSync = updated;
                        this.messageSyncParams = params;
                        // finita la sincronizzazione dei customer,
                        // applico la sincronizzazione dei rapporti di intervento
                        if (updated == 'end') {
                            this.sync.syncronizeTable('intervention_reports', (updated, params) => {
                                this.messageSync = updated;
                                this.messageSyncParams = params;

                                // finita la sincronizzazione dei rapporti di intervento,
                                // applico la sincronizzazione delle schede di controllo
                                if (updated == 'end') {
                                    this.sync.syncronizeTable('check_sheets', (updated, params) => {
                                        this.messageSync = updated;
                                        this.messageSyncParams = params;
                                        if (updated == 'end') {
                                            // fine sincronizzazione
                                            // this.toast.success(this.$t(`common.sync.complete`));
                                        }
                                    });
                                }
                            });
                        }
                    })
                }
            },
            getProfile() {
                this.loadingProfile = true;
                this.api.get('/profile', null, false)
                    .then((result) => {
                        if (result && result.success) {
                            localStorage.setItem('profile', JSON.stringify(result.data));
                        }
                    })
                    .catch(() => {
                        localStorage.removeItem('token');
                        localStorage.removeItem('profile');
                        location.href = `/`;
                    })
                    .finally(() => {
                        let profile = {};
                        try {
                            profile = JSON.parse(localStorage.getItem('profile'));
                        } catch (e) {
                        }
                        this.profile = profile;
                        this.loadingProfile = false;
                    })

            },
            toggleProfile() {
                this.profileOpen = !this.profileOpen;
            },
            toggleSidebar() {
                this.$emit('input', !this.value);
            },
            logout() {
                this.modalLogoutOpen = !this.modalLogoutOpen;
            },
            /*goProfile() {
                this.$router.push('/profile').catch(() => {
                });
            },*/
            closeLogoutModal(e) {
                if (e) {
                    this.$router.push('/login').catch(() => {
                    });
                }
            }
        }
    }
</script>
<style lang="scss">
	@import './src/scss/variables';

	.sync {
		display: flex;
		@extend %flexCenterEnd;
		background: transparent;
		@include size(auto, 80%);
		color: $middle-green;

		&__icon {
			display: flex;
			@extend %flexCenterCenter;
			@include size(40px, 40px);

			svg {
				@include size(70%, 70%);
				fill: $middle-green;
			}
		}

		&__label {
			text-transform: uppercase;
		}
	}

	.syncstatus {
		position: fixed;
		bottom: 0px;
		left: 0;
		display: flex;
		background-image: linear-gradient(to top, $black, $black);
		width: 100vw;
		font-size: 2.5em;
		line-height: 1.4em;
		color: #7bdb27;
		padding: 40px 30px 40px;
		transform: translateY(120%);
		transition: 800ms linear;
		z-index: 99999999999;

		&.active {
			transform: translateY(0%);
			transition: 200ms linear;
		}
	}
</style>
